import { defineStore } from 'pinia'
import type { PeriodTextLang } from '../helpers/formatter'

export type State = {
  lang: PeriodTextLang
  secondaryTimeZone: string | null
}

export const useInputStore = defineStore('pc-input', {
  state: (): State => ({
    lang: 'ja',
    secondaryTimeZone: null
  }),
  actions: {
    setLang(lang: PeriodTextLang) {
      this.lang = lang
    },
    setSecondaryTimeZone(tz: string | null) {
      this.secondaryTimeZone = tz
    }
  }
})
